import appendParam from './appendParam';

const appendThemeParam = (link: string = '', theme: string = '', fullLink: boolean = true) =>
  appendParam(link, 'theme', theme, fullLink);
export default appendThemeParam;
